import { trackEvent } from './splunkEventHelper';

type PendoEvent = string | { name: string; properties: Record<string, unknown> };

interface PendoTrackable {
  track: (event: string, properties?: Record<string, unknown>) => void;
}

class PendoBatcher {
  private eventQueue: PendoEvent[] = [];

  private batchTimer: ReturnType<typeof setTimeout> | null = null;
  
  private readonly BATCH_SIZE = 10;
  
  private readonly BATCH_TIMEOUT = 30 * 60 * 1000;

  flushEvents = () => {
    const pendo = window.pendo as unknown as PendoTrackable | undefined;
    if (this.eventQueue.length > 0 && pendo?.track) {
      for (const event of this.eventQueue) {
        try {
          if (typeof event === 'string') {
            pendo.track(event);
          } else {
            pendo.track(event.name, event.properties);
          }
        } catch {
          trackEvent({
            event: 'pendo-tracking-error',
            api: 'pendo',
          });
        }
      }
      this.eventQueue = [];
    }
    if (this.batchTimer) {
      clearTimeout(this.batchTimer);
      this.batchTimer = null;
    }
  };

  addEvent = (eventName: string, properties: Record<string, unknown> | null = null) => {
    const pendo = window.pendo as unknown as PendoTrackable | undefined;
    if (!pendo || typeof pendo.track !== 'function') {
      trackEvent({
        event: 'pendo-unavailable',
        api: 'pendo',
        eventName,
      });
      return;
    }

    const event: PendoEvent = properties ? { name: eventName, properties } : eventName;
    this.eventQueue.push(event);

    if (!this.batchTimer) {
      this.batchTimer = setTimeout(this.flushEvents, this.BATCH_TIMEOUT);
    }

    if (this.eventQueue.length >= this.BATCH_SIZE) {
      this.flushEvents();
    }
  };
}

export default new PendoBatcher();
